import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

/* Preventivi si apre sull'elenco, il Calcolatore è la seconda scheda (decisione del 30-10). Sono due indirizzi
   veri, così nessun link di prima si rompe: /preventivi e /preventivi/calcolatore. */
export default function StrumentiTabs({ className }) {
  const voce = ({ isActive }) =>
    cn(
      "inline-flex h-9 items-center rounded-[7px] px-3.5 transition-colors duration-150 ease-enter max-md:h-11",
      "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
      isActive ? "bg-track-on font-bold text-ink shadow-segment" : "font-medium text-ink-2 hover:text-ink",
    );
  return (
    <nav aria-label="Strumento" className={cn("inline-flex gap-0.5 rounded-md bg-track p-[3px]", className)}>
      <NavLink to="/preventivi" end className={voce} data-testid="preventivi-scheda-elenco">
        Elenco
      </NavLink>
      <NavLink to="/preventivi/calcolatore" className={voce} data-testid="preventivi-scheda-calcolatore">
        Calcolatore
      </NavLink>
    </nav>
  );
}
